import React from 'react';

const Page = ({children, singleMode, id}) => (<div
  id={id} className="bg-white shadow-1 center pa4" 
  // style={{width: "223mm", height: singleMode ? "170mm" : ""}}
  style={{height: singleMode ? "170mm" : ""}}
>
  {children}
</div>); 

export default Page;